import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=6d2ecf9a&scoped=true"
import script from "./Copy.vue?vue&type=script&lang=ts"
export * from "./Copy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2ecf9a",
  null
  
)

export default component.exports